'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextField = require('./components/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var standardLibrary = {
  text: _TextField2.default
};

exports.default = standardLibrary;


/** WEBPACK FOOTER **
 ** ../biro/lib/library/standard/index.js
 **/